<b-modal v-model="modal_requirement_130" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      <!-- 待機画面 -->
      <template v-if="phase === 'start'">
        {{ $t('individual.common_title_execution') }}
      </template>
      <!-- 実行中 -->
      <template v-if="phase === 'inProgress'">
        {{ $t('individual.common_title_execution') }}
      </template>
      <!-- 停止画面 -->
      <template v-if="phase === 'stop'">
        {{ $t('message.common_title_success') }}
      </template>
      <!-- エラー画面 -->
      <template v-if="(phase === 'error')">
        {{ $t('message.common_title_error') }}
      </template>
    </div>
  </template>

  <template v-slot:default>
    <ShowLessBOverlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <!-- 待機画面 -->
        <template v-if="phase === 'start'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle">
                <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{
                  $t(`${i18nWsKey}.REQ_WS_130_TXT_1`) }}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 実行中 -->
        <template v-if="phase === 'inProgress'">
          <div class="container-fluid mt-2 mb-2">
            <custom-Progress :value="progress" useResource :message="`${i18nWsKey}.REQ_WS_130_TXT_2`" />
          </div>
        </template>
        <!-- 停止画面 -->
        <template v-if="phase === 'stop'">
          <div class="w-100">
            <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{
              $t(`${i18nWsKey}.REQ_WS_130_TXT_3`) }}</div>
          </div>
          <!-- トレーニングモード用 速度表示 -->
          <div v-if=isTestMode class="col-12 text-right w-100 mt-4">
            <div class="text-right">{{ $t('message.label_training_execute_up_time') }} : {{ uploadTime }}
            </div>
            <div class="text-right">{{ $t('message.label_training_execute_up_speed') }} : {{ uploadSpeed }}</div>
          </div>
        </template>
        <!-- エラー画面 -->
        <template v-if="(phase === 'error')">
          <div class="w-100">
            <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{
              $t(`${i18nWsKey}.REQ_WS_130_TXT_4`) }}</div>
          </div>
        </template>
      </div>
    </ShowLessBOverlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <!-- 待機画面 -->
      <template v-if="phase === 'start'">
        <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="closeWizard" class="mx-2">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="execute" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 停止画面 -->
      <template v-if="phase === 'stop'">
        <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="download" class="mx-2">
          {{ $t('message.button_vehicle_system_download_zip') }}
        </b-button>
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="exit()" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- エラー画面 -->
      <template v-if="phase === 'error'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="exit()" class="mx-2">{{
          $t('message.common_button_ok') }}
        </b-button>
      </template>
    </div>
  </template>
</b-modal>